module.exports = __webpack_public_path__ + "img/lineup26@2x.0a447cf1.png";